module.exports = __webpack_public_path__ + "static/media/nr1lxKs2Wg.b1e107b0.jpg";